var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { attrs: { id: "intro" } }, [
      _c("h2", [_vm._v("Voraussetzungen für das Update")]),
      _vm._v(" "),
      _c("div", { staticClass: "wrapper" }, [
        _c(
          "p",
          [
            _vm._v("Für das Update auf "),
            _c("riskop15"),
            _vm._v(" benötigen Sie mindestens:"),
          ],
          1
        ),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
      ]),
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("Konfiguration")]),
    _vm._v(" "),
    _c("div", { staticClass: "wrapper" }, [
      _c("div", { attrs: { id: "selection" } }, [
        _c("p", [
          _vm._v(
            "Wählen Sie bitte hier die Konfiguration aus, auf der das Update stattfinden soll:"
          ),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "form-group row" }, [
          _vm._m(2),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2" },
            [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.currentVersion,
                      expression: "currentVersion",
                    },
                  ],
                  staticClass: "custom-select",
                  attrs: { id: "currentVersion", name: "currentVersion" },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.currentVersion = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                _vm._l(_vm.currentVersions, function (v, idx) {
                  return _c(
                    "option",
                    { key: idx, domProps: { value: v.value } },
                    [_vm._v(_vm._s(v.name))]
                  )
                }),
                0
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2" },
            [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.numerus,
                      expression: "numerus",
                    },
                  ],
                  staticClass: "custom-select",
                  attrs: { id: "numerus", name: "numerus" },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.numerus = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                _vm._l(_vm.numeri, function (v, idx) {
                  return _c(
                    "option",
                    { key: idx, domProps: { value: v.value } },
                    [_vm._v(_vm._s(v.name))]
                  )
                }),
                0
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2" },
            [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.kritikomCoinstallation,
                      expression: "kritikomCoinstallation",
                    },
                  ],
                  staticClass: "custom-select",
                  attrs: {
                    id: "kritikomCoinstallation",
                    name: "kritikomCoinstallation",
                  },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.kritikomCoinstallation = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                _vm._l(_vm.kritikomCoinstallations, function (v) {
                  return _c(
                    "option",
                    {
                      key: "coinstall_" + v.value,
                      domProps: { value: v.value },
                    },
                    [_vm._v(_vm._s(v.name))]
                  )
                }),
                0
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2" },
            [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.osType,
                      expression: "osType",
                    },
                  ],
                  staticClass: "custom-select",
                  attrs: { id: "osType", name: "osType" },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.osType = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                _vm._l(_vm.osTypes, function (v) {
                  return _c(
                    "option",
                    { key: "ostype_" + v.value, domProps: { value: v.value } },
                    [_vm._v(_vm._s(v.name))]
                  )
                }),
                0
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2" },
            [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.javaVersion,
                      expression: "javaVersion",
                    },
                  ],
                  staticClass: "custom-select",
                  attrs: { id: "javaVersion", name: "javaVersion" },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.javaVersion = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                _vm._l(_vm.javaVersions, function (v) {
                  return _c(
                    "option",
                    { key: "java_" + v.value, domProps: { value: v.value } },
                    [_vm._v(_vm._s(v.name))]
                  )
                }),
                0
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2" },
            [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.tomcatVersion,
                      expression: "tomcatVersion",
                    },
                  ],
                  staticClass: "custom-select",
                  attrs: { id: "tomcatVersion", name: "tomcatVersion" },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.tomcatVersion = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                _vm._l(_vm.tomcatVersions, function (v) {
                  return _c(
                    "option",
                    { key: "tomcat_" + v.value, domProps: { value: v.value } },
                    [_vm._v(_vm._s(v.name))]
                  )
                }),
                0
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2" },
            [
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.dbType,
                      expression: "dbType",
                    },
                  ],
                  staticClass: "custom-select",
                  attrs: { id: "dbType", name: "dbType" },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.dbType = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    },
                  },
                },
                _vm._l(_vm.dbTypes, function (v) {
                  return _c(
                    "option",
                    { key: "dbtype_" + v.value, domProps: { value: v.value } },
                    [_vm._v(_vm._s(v.name))]
                  )
                }),
                0
              ),
            ]
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm.numerus == "multi" || _vm.kritikomCoinstallation == "yes"
        ? _c("div", { staticClass: "alert alert-warning" }, [
            _c("ul", [
              _vm.numerus == "multi"
                ? _c("li", [
                    _vm._v(
                      "\n\t\t\t\t\tBei mehreren riskop-Instanzen in einem Tomcat sollten die riskop-Instanzen mit der gleichen Version\n\t\t\t\t\tinstalliert sein, da sich die Versions-Anforderungen an gemeinsame Resourcen wie Java, Tomcat und\n\t\t\t\t\tDatenbanktreiber unterscheiden können.\n\t\t\t\t"
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.kritikomCoinstallation == "yes"
                ? _c("li", [
                    _c("strong", [_vm._v("kritikom-1")]),
                    _vm._v(
                      " ist erst ab der Version 1.3.5 kompatibel mit Java 9-14. "
                    ),
                    _c("strong", [
                      _vm._v(
                        "Bitte führen Sie\n\t\t\t\t\tggf. auch hier ein Update durch!"
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("Download von riskop")]),
    _vm._v(" "),
    _c("div", { staticClass: "wrapper" }, [
      _c(
        "p",
        [
          _vm._v("Die für das Update von "),
          _c("riskop15"),
          _vm._v(" notwendigen Java-Web-Anwendung "),
          _c("code", [_vm._v("riskop.war")]),
          _vm._v(" und die Konfigurationsdatei "),
          _c("code", [_vm._v("riskop.properties")]),
          _vm._v(" befinden\n\t\t\tsich in einem ZIP-Archiv."),
        ],
        1
      ),
      _vm._v(" "),
      _vm._m(3),
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("Vorbereitung des Updates")]),
    _vm._v(" "),
    _c("div", { staticClass: "wrapper" }, [
      _c("h3", [_vm._v("Sichern der bestehenden Installation")]),
      _vm._v(" "),
      _c(
        "p",
        [
          _vm._v("Sichern Sie am besten das gesamte "),
          _c("tomcat-path", { attrs: { os: _vm.osType, path: "" } }),
          _vm._v("-Verzeichnis in ein ZIP-Archiv."),
        ],
        1
      ),
      _vm._v(" "),
      _c("h3", [_vm._v("Tomcat Dienst stoppen")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Der Tomcat sollte vor dem Sichern der DB und dem Durchführen des Updates gestoppt werden."
        ),
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v("Backup der Datenbank")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "alert alert-warning" },
        [
          _vm._v("\n\t\t\tIm Update-Prozess führt "),
          _c("riskop15"),
          _vm._v(
            " Schema-Änderungen auf der Datenbank durch. Daher ist ein Datenbank-Backup notwendig,\n\t\t\tum bei Problemen beim Update-Prozess wieder auf die alte Version zurückrollen zu können.\n\t\t"
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.dbType == "postgres"
        ? _c("div", [
            _c("p", [_vm._v("Für " + _vm._s(_vm.dbName) + " verwenden Sie")]),
            _vm._v(" "),
            _c(
              "p",
              [
                _c("pg-cmd", {
                  attrs: {
                    os: _vm.osType,
                    cmd: "pg_dump",
                    args: "-U <riskop DB user> -f riskop_backup.sql <riskop DB name>",
                  },
                }),
              ],
              1
            ),
          ])
        : _c("div", [
            _c("p", [
              _vm._v(
                "Für " +
                  _vm._s(_vm.dbName) +
                  " folgen Sie bitte den Anleitungen des Datenbankherstellers."
              ),
            ]),
          ]),
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("Anwendung ersetzen")]),
    _vm._v(" "),
    _c("div", { staticClass: "wrapper" }, [
      _c(
        "p",
        [
          _vm._v("Kopieren Sie die Datei "),
          _c("code", [_vm._v("riskop.war")]),
          _vm._v(" aus dem riskop-ZIP-Archiv in das Tomcat-Verzeichnis "),
          _c("tomcat-path", { attrs: { os: _vm.osType, path: "webapps" } }),
        ],
        1
      ),
      _vm.numerus == "multi"
        ? _c(
            "div",
            [
              _vm._v("\n\t\tBei mehreren "),
              _c("riskop15"),
              _vm._v(
                "-Instanzen in einem Tomcat werden die Instanzen über den Namen der "
              ),
              _c("code", [_vm._v("war")]),
              _vm._v("-Datei im \n\t\t"),
              _c("tomcat-path", { attrs: { os: _vm.osType, path: "webapps" } }),
              _vm._v(
                " unterschieden. Ersetzen sie diese Dateien für jede riskop-Instanz, die aktualisiert werden soll,\n\t\tdurch das neue "
              ),
              _c("code", [_vm._v("riskop.war")]),
              _vm._v(
                ". Achten Sie auf den korrekten Namen der Datei, da aus diesem die URL zum Aufruf der Instanzen\n\t\tgebildet wird und die Konfigurationsdateien den Instanzen zugeordnet werden.\n\t"
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("Konfiguration anpassen")]),
    _vm._v(" "),
    _vm.currentVersion == "1.5"
      ? _c("div", { staticClass: "alert alert-success" }, [
          _vm._v(
            "\n\t\tDa Sie bereits riskop in der Version 1.5 nutzen, müssen keine Anpassungen an der Konfiguration vorgenommen werden.\n\t"
          ),
        ])
      : _c("div", [
          _c(
            "div",
            { staticClass: "wrapper" },
            [
              _c("h4", [_vm._v("Datenbank-Verbindungs-Parameter")]),
              _vm._v(
                "\n\t\tMit der Version 1.5 sind die Datenbank-Verbindungsparameter aus "
              ),
              _c("tomcat-path", {
                attrs: {
                  os: _vm.osType,
                  path: "conf/Catalina/localhost/riskop.xml",
                },
              }),
              _vm._v("\n\t\tnach "),
              _c("tomcat-path", {
                attrs: { os: _vm.osType, path: "conf/riskop.properties" },
              }),
              _vm._v(" gewandert.\n\t\tÜbernehmen Sie die Werte aus "),
              _c("code", [_vm._v("riskop.xml")]),
              _vm._v(" in neue Parameter\n\t\t\tin "),
              _c("code", [_vm._v("riskop.properties")]),
              _vm._v(":\n\t\t"),
              _vm._m(4),
              _vm._v(" "),
              _vm.currentVersion == "1.2-3"
                ? _c(
                    "div",
                    [
                      _c("h4", [_vm._v("Weiterleitung an CIRSmedical")]),
                      _vm._v(
                        "\n\t\t\tMit der Version 1.4 wurden die Parameter zur Weiterleitung an CIRSmedical geändert.\n\t\t\t"
                      ),
                      _vm._m(5),
                      _vm._v(" "),
                      _vm._m(6),
                      _vm._v(" "),
                      _vm._m(7),
                      _vm._v(" "),
                      _c("h4", [_vm._v("Sprachkonfiguration")]),
                      _vm._v("\n\t\t\tFügen Sie die Zeile "),
                      _c("code", [_vm._v("application.locale=de")]),
                      _vm._v(" ein, um Deutsch als Standard-Sprache für "),
                      _c("riskop15"),
                      _vm._v(" einzustellen.\n\t\t"),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.numerus == "multi"
                ? _c(
                    "div",
                    [
                      _c("h4", [
                        _vm._v("Vorgehen bei mehreren riskop-Instanzen"),
                      ]),
                      _vm._v("\n\t\t\tBei mehreren "),
                      _c("riskop15"),
                      _vm._v(
                        "-Instanzen in einem Tomcat hat jede Instanz ihre eigene Konfiguration. Die Zuordnung erfolgt über die Dateinamen. Sie müssen daher die \n\t\t\tAnpassung jeweils für alle Instanzen durchführen.\n\t\t"
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
    _vm._v(" "),
    _c("h2", [_vm._v("JDBC-Datenbanktreiber aktualisieren")]),
    _vm._v(" "),
    _vm.currentVersion == "1.5"
      ? _c("div", { staticClass: "alert alert-success" }, [
          _vm._v(
            "\n\t\tDa Sie bereits riskop in der Version 1.5 nutzen, sollte der DB-Treiber bereits auf dem aktuellen Stand sein.\n\t"
          ),
        ])
      : _c("div", [
          _c("div", { staticClass: "wrapper" }, [
            _c(
              "p",
              [
                _vm._v("Der Datenbanktreiber ist ein sogenannter "),
                _c("code", [_vm._v("JDBC")]),
                _vm._v("-Treiber und muss im Verzeichnis "),
                _c("tomcat-path", { attrs: { os: _vm.osType, path: "lib" } }),
                _vm._v(" abgelegt werden."),
              ],
              1
            ),
            _vm._v(" "),
            _vm.dbType == "postgres"
              ? _c(
                  "div",
                  [
                    _c("riskop15"),
                    _vm._v(
                      " benötigt für " +
                        _vm._s(_vm.dbName) +
                        " einen aktuellen JDBC-Treiber der 42-er Reihe. \n\t\t\tFür " +
                        _vm._s(_vm.javaName) +
                        " ist das "
                    ),
                    _c("code", [_vm._v("postgresql-42.x.x.jar")]),
                    _vm._v(".\n\t\t\tPrüfen sie, ob sich im "),
                    _c("tomcat-path", {
                      attrs: { os: _vm.osType, path: "lib" },
                    }),
                    _vm._v(
                      " ein passender Treiber befindet. Wenn nicht, löschen Sie ggf. den alten\n\t\t\t"
                    ),
                    _c("code", [_vm._v("postgresql...jar")]),
                    _vm._v(
                      " Treiber und installieren den für Sie passenden von \n\t\t\t"
                    ),
                    _c(
                      "a",
                      {
                        attrs: {
                          title: "PG JDBC",
                          href: "https://jdbc.postgresql.org/download.html",
                          target: "_blank",
                        },
                      },
                      [_vm._v("Postgres JDBC Downloads")]
                    ),
                    _vm._v(".\n\t\t\t"),
                    _c(
                      "div",
                      { staticClass: "alert alert-warning" },
                      [
                        _vm._v("Die Treiber aus der "),
                        _c("code", [_vm._v("postgresql-9.x...jar")]),
                        _vm._v(" Linie funktionieren mit "),
                        _c("riskop15"),
                        _vm._v(" nicht mehr."),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.dbType == "mssql"
              ? _c("div", [
                  _c(
                    "p",
                    [
                      _c("riskop15"),
                      _vm._v(
                        " benötigt für " +
                          _vm._s(_vm.dbName) +
                          " einen JDBC-Treiber von\n\t\t\t\t"
                      ),
                      _c(
                        "a",
                        {
                          attrs: {
                            title: "MS SQL JDBC",
                            href: "https://www.microsoft.com/de-de/download/details.aspx?id=11774",
                            target: "_blank",
                          },
                        },
                        [_vm._v("MSSQL JDBC")]
                      ),
                      _vm._v(".\n\t\t\t"),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._m(8),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.dbType == "mysql"
              ? _c("div", [
                  _c("p", [
                    _vm._v(
                      "Den JDBC-Treiber zu " +
                        _vm._s(_vm.dbName) +
                        " finden Sie auf\n\t\t\t"
                    ),
                    _c(
                      "a",
                      {
                        attrs: {
                          title: "MySQL JDBC",
                          href: "https://dev.mysql.com/downloads/connector/j/",
                          target: "_blank",
                        },
                      },
                      [_vm._v("Connector-J Downloads")]
                    ),
                    _vm._v("."),
                  ]),
                  _vm._v(" "),
                  _vm._m(9),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "alert alert-warning" },
              [
                _vm._v("Falls sie einen neuen Treiber nach "),
                _c("tomcat-path", { attrs: { os: _vm.osType, path: "lib" } }),
                _vm._v(" installieren, löschen Sie ggf. den alten."),
              ],
              1
            ),
          ]),
        ]),
    _vm._v(" "),
    _vm.currentVersion != 1.5
      ? _c("div", [
          _c("h2", [_vm._v("Entfernen alter Konfigurationsdateien")]),
          _vm._v(" "),
          _c("div", { staticClass: "wrapper" }, [
            _c("p", [
              _vm._v(
                "Mit der Version 1.5 werden folgende Konfigurationsdateien nicht mehr benötigt:"
              ),
            ]),
            _vm._v(" "),
            _c("ul", [
              _c(
                "li",
                [
                  _c("tomcat-path", {
                    attrs: {
                      os: _vm.osType,
                      path: "conf/riskop_hibernate.cfg.xml",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "li",
                [
                  _c("tomcat-path", {
                    attrs: {
                      os: _vm.osType,
                      path: "conf/Catalina/localhost/riskop.xml",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm.numerus == "multi"
              ? _c(
                  "div",
                  [
                    _vm._v("\n\t\t\tBei mehreren "),
                    _c("riskop15"),
                    _vm._v(
                      "-Instanzen in einem Tomcat müssen Sie diese Konfigurationsdateien jeweils für die einzelnen Instanzen entfernen.\n\t\t\tDie Zuordnung erfolgt über die Dateinamen. \n\t\t"
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "alert alert-warning" },
              [
                _vm._v("\n\t\t\tInsbesondere eine alte "),
                _c("tomcat-path", {
                  attrs: {
                    os: _vm.osType,
                    path: "conf/Catalina/localhost/riskop.xml",
                  },
                }),
                _vm._v(
                  " kann zu Fehlern beim Start des Tomcat führen.\n\t\t\tDaher muss diese Datei entweder aus dem "
                ),
                _c("tomcat-path", {
                  attrs: { os: _vm.osType, path: "conf/Catalina/localhost/" },
                }),
                _vm._v(
                  " Verzeichnis verschoben oder gelöscht oder \n\t\t\tso umbenannt werden, dass der Tomcat sie nicht mehr öffnet (z.B. durch die Dateiendung "
                ),
                _c("code", [_vm._v(".bak")]),
                _vm._v(").\n\t\t"),
              ],
              1
            ),
          ]),
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("h2", [_vm._v("Entfernen alter Temporärer Verzeichnisse")]),
    _vm._v(" "),
    _c("div", { staticClass: "wrapper" }, [
      _c("p", [
        _vm._v(
          "Gelegentlich kommt es nach Updates zu Problemen beim Neustart des Tomcat, wenn noch temporäre Dateien der alten Version vorhanden sind.\n\tLöschen Sie daher folgende Verzeichnisse:"
        ),
      ]),
      _vm._v(" "),
      _c("ul", [
        _c(
          "li",
          [
            _c("tomcat-path", {
              attrs: { os: _vm.osType, path: "webapps/riskop" },
            }),
            _vm._v(" (die vom Tomcat ausgepackte Anwendung)"),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "li",
          [
            _c("tomcat-path", {
              attrs: { os: _vm.osType, path: "work/Catalina/localhost/riskop" },
            }),
            _vm._v(" (alte Session-Daten)"),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.numerus == "multi"
        ? _c(
            "div",
            [
              _vm._v("\n\t\tBei mehreren "),
              _c("riskop15"),
              _vm._v(
                "-Instanzen hat jede Instanz ihre eigenen temporären Verzeichnisse, die Sie am Instanznamen erkennen.\n\t\tLöschen Sie diese Verzeichnisse für alle aktualisierten Instanzen.\n\t"
              ),
            ],
            1
          )
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("Tomcat Starten")]),
    _vm._v(" "),
    _c("div", { staticClass: "wrapper" }, [
      _vm._v("\n\tStarten Sie jetzt wieder den Tomcat-Dienst.\n\t"),
    ]),
    _vm._v(" "),
    _c("h2", [_vm._v("Update Abschließen und Testen")]),
    _vm._v(" "),
    _c("div", { staticClass: "wrapper" }, [
      _c("p", [
        _vm._v(
          "Wenn der Dienst vollständig gestartet ist (das kann das erste Mal bis zu einer Minute dauern) kann das Update\n      über folgende URL fertig gestellt werden:"
        ),
      ]),
      _vm._v(" "),
      _vm._m(10),
      _vm._v(" "),
      _c("p", [
        _vm._v("Autorisieren Sie sich durch hochladen Ihrer Lizenzdatei."),
      ]),
      _vm._v(" "),
      _vm._m(11),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Jetzt sollten Sie die Anwendung normal aufrufen und nutzen können."
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "alert alert-info" }, [
        _vm._v(
          "\n\t\tFalls Sie an dieser Stelle eine Fehlermeldung bekommen oder irgendetwas anderes nicht funktioniert, können Sie gerne\n\t\tunseren "
        ),
        _c(
          "a",
          {
            attrs: { href: _vm.context + "/kontakt/support", target: "_blank" },
          },
          [_vm._v("Support")]
        ),
        _vm._v(" kontaktieren!\n\t"),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", [
        _vm._v("Java 8-14 (empfohlen "),
        _c("strong", [_vm._v("Java 11")]),
        _vm._v(")"),
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v("Apache Tomcat 7-9 (empfohlen "),
        _c("strong", [_vm._v("Version 9")]),
        _vm._v(")"),
      ]),
      _vm._v(" "),
      _c("li", [
        _vm._v("Aktuelles Datenbanksystem:\n\t\t\t\t\t"),
        _c("ul", [
          _c("li", [
            _c("strong", [_vm._v("PostgreSQL")]),
            _vm._v(" (ab Version 9, empfohlen "),
            _c("strong", [_vm._v("Version 12")]),
            _vm._v(") oder"),
          ]),
          _vm._v(" "),
          _c("li", [_vm._v("mysql (ab Version 5.6) oder")]),
          _vm._v(" "),
          _c("li", [_vm._v("MS-SQL-Server ab Version 2008")]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "Falls Ihre System diese Voraussetzungen nicht erfüllt, führen Sie bitte zunächst die Installation der neuen Komponenten entsprechend der\n\t\t\t\t"
      ),
      _c("a", { attrs: { href: "installation" } }, [
        _vm._v("Installationsanleitung"),
      ]),
      _vm._v(" durch.\n\t\t\t"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "col-sm-12 col-md-6 col-lg-3 col-xl-3 mb-2" },
      [_c("p", [_vm._v("Aktuell installierte Version:")])]
    )
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("Dieses Archiv können Sie unter\n\t\t\t"),
      _c(
        "a",
        {
          attrs: {
            href: "https://www.fumix.de/kunden-login",
            target: "_blank",
          },
        },
        [_vm._v("Kunden-Login")]
      ),
      _vm._v(
        " herunterladen, nachdem Sie sich dort durch Upload Ihrer aktuellen\n\t\t\tLizenz authentifiziert haben.\n\t\t"
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("pre", [
      _vm._v("db.connection.url="),
      _c("strong", [
        _vm._v("Attribut "),
        _c("em", [_vm._v("url")]),
        _vm._v(" aus riskop.xml"),
      ]),
      _vm._v("\ndb.connection.username="),
      _c("strong", [
        _vm._v("Attribut "),
        _c("em", [_vm._v("username")]),
        _vm._v(" aus riskop.xml"),
      ]),
      _vm._v("\ndb.connection.password="),
      _c("strong", [
        _vm._v("Attribut "),
        _c("em", [_vm._v("password")]),
        _vm._v(" aus riskop.xml"),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", [
      _c("li", [
        _c("strong", [_vm._v("Alt:")]),
        _vm._v(" "),
        _c("pre", [
          _vm._v(
            "#RIPA_CIRS_CSV_ADDRESS=<Mailadresse<\n#RIPA_CIRS_MEDICAL_ID=<cirs medical id<\n#RIPA_CIRS_INTERFACE_ID=<interface_id<"
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("li", [
        _c("strong", [_vm._v("Neu:")]),
        _vm._v(" "),
        _c("pre", [
          _vm._v(
            "# Valid values are NONE, CIRS_MEDICAL, CIRS_NETZ_DE.\nEXTERNAL_CIRS=NONE"
          ),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "Falls der Versand and CIRSmedical genutzt werden soll, tragen Sie "
      ),
      _c("code", [_vm._v("EXTERNAL_CIRS=CIRS_MEDICAL")]),
      _vm._v(" ein, ansonsten "),
      _c("code", [_vm._v("EXTERNAL_CIRS=NONE")]),
      _vm._v(".\n\t\t\tDie alten "),
      _c("code", [_vm._v("RIPA_CIRS...")]),
      _vm._v(" Zeilen können Sie löschen."),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "alert alert-info" }, [
      _vm._v(
        "\n\t\t\t\tIn der alten Konfiguration war der Versand deaktiviert, wenn die "
      ),
      _c("code", [_vm._v("RIPA")]),
      _vm._v("-Parameter durch einen "),
      _c("strong", [_vm._v("#")]),
      _vm._v(" auskommentiert waren.\n\t\t\t"),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v("Beachten Sie bitte, dass für Java 8+ der "),
      _c("code", [_vm._v("JDBC 4.2")]),
      _vm._v(" Treiber\n\t\t\t\tbenötigt wird."),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "Informationen\n\t\t\t\tzur Kompatiblität der Treiber-Versionen finden Sie auf "
      ),
      _c(
        "a",
        {
          attrs: {
            title: "MySQL JDBC",
            href: "https://dev.mysql.com/doc/connector-j/8.0/en/connector-j-versions.html",
            target: "_blank",
          },
        },
        [_vm._v("Connector-J Versionen")]
      ),
      _vm._v("."),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c(
        "a",
        {
          attrs: {
            href: "http://localhost:8080/riskop/admin/Start.do",
            target: "_blank",
          },
        },
        [_vm._v("http://localhost:8080/riskop/admin/Start.do")]
      ),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _vm._v(
        "Die Anwendung erkennt selbstständig, ob für die neue Version Änderungen des Datenbankschemas notwendig sind. Falls ja,\n\t\terscheint ein "
      ),
      _c("strong", [_vm._v("Datenbank aktualisieren")]),
      _vm._v("-Button, mit dem Sie das Schema-Update durchführen.\n\t"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }